// @tennis-matches/services/ranking
import { getSupabaseClient } from "../supabase/index.js";

const TABLE = "tournament_rankings";

function __asStr(v) { return String(v ?? "").trim(); }

/**
 * Load ranking snapshot for a tournament (tournament_id is TEXT = your code e.g. HGTLJ4).
 */
export async function loadTournamentRankingByCode(code) {
  const c = __asStr(code);
  if (!c) return { ok: false, reason: "missing-code" };

  try {
    const supabase = await getSupabaseClient();
    if (!supabase) return { ok: false, reason: "no-supabase" };

    const { data, error } = await supabase
      .from(TABLE)
      .select("tournament_id, payload, updated_at")
      .eq("tournament_id", c)
      .limit(1)
      .maybeSingle();

    if (error) return { ok: false, reason: "db-error", error };
    if (!data?.payload) return { ok: false, reason: "not-found" };

    return { ok: true, code: __asStr(data.tournament_id), payload: data.payload, updatedAt: data.updated_at || null };
  } catch (e) {
    return { ok: false, reason: "exception", error: e };
  }
}

/**
 * Upsert ranking snapshot for a tournament (tournament_id is TEXT = your code).
 */
export async function upsertTournamentRankingByCode(code, payload) {
  const c = __asStr(code);
  if (!c) return { ok: false, reason: "missing-code" };
  if (!payload || typeof payload !== "object") return { ok: false, reason: "missing-payload" };

  try {
    const supabase = await getSupabaseClient();
    if (!supabase) return { ok: false, reason: "no-supabase" };

    const row = { tournament_id: c, payload };

    // Requires a unique constraint on tournament_id (recommended).
    const { error } = await supabase
      .from(TABLE)
      .upsert(row, { onConflict: "tournament_id" });

    if (error) return { ok: false, reason: "db-error", error };
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: "exception", error: e };
  }
}
